<div class="checkbox"
    [class.checkbox--checked]="checked"
    [class.checkbox--disabled]="disabled"
></div>
